import { orchestrator } from 'satcheljs';
import { onCopilotChatDrawerReady } from 'owa-copilot-chat-drawer-store';
import { handleCopilotChatAutoOpen } from '../utils/handleCopilotChatAutoOpen';
import { getPendingAutoOpenOperation } from '../utils/tryAutoOpen';
import tryRunPendingAutoOpenOperation from '../utils/tryRunPendingAutoOpenOperation';

// Once the Chat Drawer is rendered, trigger any pending auto-open operation
// This is important so that we can auto-open the drawer after the container is ready
orchestrator(onCopilotChatDrawerReady, () => {
    if (getPendingAutoOpenOperation() === handleCopilotChatAutoOpen) {
        tryRunPendingAutoOpenOperation();
    }
});
